export const handleApiErrors = async response => {
  if (!response.ok) {
    const errorDetails = await response.json()
    let error
    if (errorDetails.developerText) {
      // error coming from entitlements API
      error = new Error(errorDetails.developerText)
      error.name = 'AccountError'
      error.statusCode = 204
    } else {
      // error coming from host-ol
      error = new Error(errorDetails.message)
      error.name = errorDetails.name
      error.statusCode = errorDetails.statusCode
    }
    throw error
  }
  return response.json()
}
